import React, {useState, useEffect} from 'react'
import Image from 'next/image'
import Logo from '../public/logo.png'
import PowerOff from '../public/power-off.png'
import Link from 'next/link'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPowerOff} from '@fortawesome/free-solid-svg-icons'
import OrderSelect from './OrderSelectMobile';
import { getOrderSelectLabel } from '../utils/tiktokOrderDisplay';
const MainHeader = (props) => {
  const { orderID, order, handleOrderChange, ordersList, isTiktok } = props;
  const logoutUser = () => {
    localStorage.removeItem('dangle-it-crm:lookup-state')
    window.location.href = '/'
  }
  const [minWidth, setMinWidth] = useState('187px');
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    if (ordersList?.length > 0) {
      const selectedOption = ordersList.find(order => order.source_id === orderID);
      if (selectedOption) {
        // Match the text format used in OrderSelect
        const selectedText = `Order #${getOrderSelectLabel(selectedOption)}`;
        const textLength = selectedText.length;
        const calculatedWidth = textLength < 14 ? '187px' : '245px';  // Or your formula
        setMinWidth(calculatedWidth);
      }
    }
  }, [orderID, ordersList]);  

  const handleMinWidthChange = (e) => {
    const selectedText = e.target.options[e.target.selectedIndex].text;
    const textLength = selectedText.length;
    const calculatedWidth = textLength < 12 ? '50%' : '60%';  // Adjust as needed
    setMinWidth(calculatedWidth);
    console.log(calculatedWidth);
  };

  
  return (
    <div className="container">
      <div className="header_box">
        <div className="brand-logo">
          <Image alt="" src={Logo} />
        </div>
        <div className="mob-show order-id" style={{ minWidth: isMobile ? minWidth : undefined }}>
          {isMobile && (
            <OrderSelect
              ordersList={ordersList}
              currentOrderID={orderID}
              handleOrderChange={handleOrderChange}
              handleMinWidthChange={handleMinWidthChange}
              mobHide={false}
              isTiktok={isTiktok}
            />
          )}
        </div>
        {!isMobile && (
          <div className="logout_btn">
            <button onClick={() => logoutUser()}>
              <a>
                <span className="power_logo">
                  <FontAwesomeIcon icon={faPowerOff} />
                </span>
                <span className="semi-bold">Log Out</span>
              </a>
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default MainHeader
